import { toast } from "react-toastify";
import { ALBARANES_API } from "../views/MainLayout/components/shared/services/albaranes";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialAlbaranes = []

export const albaranesReducer = (state = initialAlbaranes, action) => {
    switch(action.type){
        case "albaranes/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchAlbaranes = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await ALBARANES_API.get(page, search)
        const data = await response.data;
        dispatch({ type: 'albaranes/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}